import React, { useEffect, useState } from 'react';
import { LoginCallback, SecureRoute, useOktaAuth } from '@okta/okta-react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import LoginPage from '../auth/LoginPage';
import SystemManagement from '../admin/SystemManagement';
import { Spinner } from '../components/';
import Toast from '../components/toast/Toast';
import Modal from '../components/modal/Modal';
import Timer from '../components/timer/Timer';

import { setGlobalHeader } from '../util/http';

import { GA_EVENT_PAGE_VIEW, sendEventToGA } from '../analytics/constants';

import '../styles/critical/_index.styl';
import '../styles/nonCritical/_index.styl';

import { getCurrentUser } from '../user/actions';

const RedirectToCatalogs = () => <Redirect to='/catalogs' />;

export const Root = () => {
  const dispatch = useDispatch();
  const oktaAuth = useOktaAuth();
  const location = useLocation();
  const { authState } = oktaAuth;
  const { isAuthenticated, accessToken } = authState || {};
  const [hasSetGlobalAuthHeader, setHasSetGlobalAuthHeader] = useState(false);
  const isPending = !authState;

  useEffect(() => {
    if (isAuthenticated && !isPending) {
      if (accessToken) {
        setGlobalHeader('Authorization', `Bearer ${accessToken.accessToken}`);
        setHasSetGlobalAuthHeader(true);
      }
    }
  }, [isAuthenticated, isPending, accessToken]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getCurrentUser());
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      sendEventToGA(GA_EVENT_PAGE_VIEW, {
        pathname: location.pathname
      });
    }
  }, [location.pathname, isAuthenticated]);

  return (
    <div className='body-3 u-full-height d-sm-flx flx-dir-sm-c'>
      <div className='app-container'>
        {isPending && !isAuthenticated && <Spinner large />}
        <Switch>
          <Route path='/login/callback' exact component={LoginCallback} />
          <Route path='/login' exact component={LoginPage} />
          <SecureRoute path='/' exact component={RedirectToCatalogs} />
          <SecureRoute path='/' component={hasSetGlobalAuthHeader ? SystemManagement : () => <Spinner large />} />
        </Switch>
      </div>

      <Modal />
      <Toast />
      {isAuthenticated && <Timer />}
    </div>
  );
};

export default Root;
